export default "__VITE_ASSET__DYJIuhYb__"